<template>
    <Dialog v-bind:value="value" @input="$emit('input', $event)"
            title="Json Vergleich" width="95%"
            hide-buttons>
        <v-row class="mb-0">
            <v-col v-for="side in ['left', 'right']" :key="side"
                   :class="{'pl-6 pr-10': side === 'left', 'pl-0': side === 'right'}">
                <v-row no-gutters>
                    <v-col cols="12">
                        <div class="d-flex align-center">
                            <LiveStageToggle style="width: 150px" v-model="$data[side].type"></LiveStageToggle>
                            <SiteSelect style="width:40%" hide-add v-model="$data[side].selectedSite" hide-details
                                        ignore-publisher-filter :loading="$data[side].siteLoading"></SiteSelect>
                            <SitetypeSelect style="width:40%"
                                            v-model="$data[side].selectedSitetype"
                                            :siteDetails="$data[side].siteDetails ? $data[side].siteDetails : {}"
                                            hide-buttons :loading="$data[side].sitetypeLoading"></SitetypeSelect>
                        </div>
                    </v-col>
                    <v-col class="pr-2 pt-2">
                        <JsonTemplatesDropdown v-model="$data[side].selectedKey"
                                               :items="getJsonKeys(side)"></JsonTemplatesDropdown>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <code-diff
            :old-string="leftTxt_pretty"
            :new-string="rightTxt_pretty"
            :isShowNoChange="true"
            :context="100"
            output-format="side-by-side"/>
    </Dialog>
</template>

<script>
import Dialog from "../../components/Dialog";
import Utils from "../../scripts/Utils";
import LiveStageToggle from "./components/LiveStageToggle";
import SiteSelect from "../components/SiteSelect";
import SitetypeSelect from "../components/SitetypeSelect";
import ada from "../../scss/ada_colors.scss";
import JsonTemplatesDropdown from "./components/JsonTemplatesDropdown";

export default {
    name: "JsonCodeDiff",
    components: {JsonTemplatesDropdown, SitetypeSelect, SiteSelect, LiveStageToggle, Dialog},
    props: ['value'],
    data: () => {
        return {
            //leftTxt: "<article class=\"teaser teaser--context-relateds group-teaserlist__item group-teaserlist__item--teaser item--context-group-teaserlist teaser--overlay-link\"> <a class=\"teaser__link teaser--card__link\" href=\"[clickUrl]\"> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <div class=\"teaser__text-content\"> <h3 class=\"teaser__headline-wrapper\"> <span class=\"teaser__kicker u-typo u-typo--kicker-tg4\">[headline1]</span> <div class=\"teaser__headline u-typo u-typo--teaser-title-tg4\">[text1]</div> </h3> <div class=\"ad-sponsors teaser__ad-sponsors\"> <div class=\"ad-sponsors__item\"> <span class=\"ad-sponsors__name u-typo u-typo--ad-label\">[text3]</span> </div> </div> </div> </a>\n</article>",
            //rightTxt: '',
            //rightTxt: "<article class=\"teaser teaser--context-relateds group-teaserlist__item group-teaserlist__item--teaser item--context-group-teaserlist teaser--overlay-link\"> <a class=\"teaser__link teaser--card__link\" href=\"[clickUrl]\"> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <div class=\"teaser__text-content\"> <h3 class=\"teaser__headline-wrapper\"> <span class=\"teaser__kicker u-typo u-typo--kicker-tg4\">[headline1]</span> <div class=\"teaser__headline u-typo u-typo--teaser-title-tg4\">[text1]</div> </h3> <div class=\"ad-sponsors teaser__ad-sponsors\"> <div class=\"ad-sponsors__item\"> <span class=\"ad-sponsors__name u-typo u-typo--ad-label\">[text3]</span> </div> </div> </div> </a>\n</article>",
            //rightTxt: "<article class=\"teaser teaser--context-relateds group-teaserlist__item group-teaserlist__item--teaser item--context-group-teaserlist teaser--overlay-link\"> <a class=\"teaser__link teaser--card__link\" href=\"[clickUrl]\"> <figure class=\"teaser__figure\"> <div class=\"teaser__image-clip-path\"> <img class=\"image teaser__image\" src=\"[imageUrl]\" loading=\"lazy\"> </div> </figure> <div class=\"teaser__text-content\"> <div class=\"ad-labels teaser__ad-labels u-typo u-typo--ad-label\"> <span class=\"ad-labels__item\">Anzeige</span> </div> <h3 class=\"teaser__headline-wrapper\"> <span class=\"teaser__kicker u-typo u-typo--kicker-tg4\">[headline1]</span> <div class=\"teaser__headline u-typo u-typo--teaser-title-tg4\">[text1]</div> </h3> <div class=\"ad-sponsors teaser__ad-sponsors\"> <div class=\"ad-sponsors__item\"> <span class=\"ad-sponsors__name u-typo u-typo--ad-label\">[text3]</span> </div> </div> </div> </a>\n</article>\n",
            left: {
                type: 'live',
                selectedSite: null,
                selectedSitetype: null,
                siteDetails: null,
                jsonContent_live: null,
                jsonContent_stage: null,
                selectedKey: null,
                siteLoading: false,
                sitetypeLoading: false,
            },
            right: {
                type: 'stage',
                selectedSite: null,
                selectedSitetype: null,
                siteDetails: null,
                jsonContent_live: null,
                jsonContent_stage: null,
                selectedKey: null,
                siteLoading: false,
                sitetypeLoading: false,
            },
            initializing: false,
            ada,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.editor;
        },
        leftTxt_pretty() {
            if (this.left.sitetypeLoading) {
                return 'loading';
            } else {
                return this.left.selectedKey ?
                    (typeof this.left["jsonContent_" + this.left.type] !== "undefined" &&
                    typeof this.left["jsonContent_" + this.left.type][this.left.selectedKey.completeKey] !== "undefined" ?
                        Utils.prettifyHTML(this.left["jsonContent_" + this.left.type][this.left.selectedKey.completeKey].trim()) : null) :
                    JSON.stringify(this.left["jsonContent_" + this.left.type], null, 1);
            }
        },
        rightTxt_pretty() {
            if (this.right.sitetypeLoading) {
                return 'loading';
            } else {
                return this.right.selectedKey ?
                    (typeof this.right["jsonContent_" + this.right.type] !== "undefined" &&
                    typeof this.right["jsonContent_" + this.right.type][this.right.selectedKey.completeKey] !== "undefined" ?
                        Utils.prettifyHTML(this.right["jsonContent_" + this.right.type][this.right.selectedKey.completeKey].trim()) : null) :
                    JSON.stringify(this.right["jsonContent_" + this.right.type], null, 1);
            }
        },
        c_left() { //just for watching, watching the model itself returns same newValue === oldValue
            return Object.assign({}, this.left);
        },
        c_right() { //just for watching
            return Object.assign({}, this.right);
        },
        jsonContent_live() {
            return this.vuexState.jsonContent_live;
        },
        selectedEntry() {
            return this.vuexState.selectedEntry;
        }
    },
    methods: {
        init() {
            if (this.jsonContent_live) {
                this.initializing = true;
                ['left', 'right'].forEach((side) => {
                    this[side].type = side === 'left' ? 'live' : 'stage';
                    this[side].selectedSite = this.vuexState.selectedSite;
                    this[side].siteDetails = this.vuexState.siteDetails;
                    this[side].selectedSitetype = this.vuexState.selectedSitetype;
                    this[side].jsonContent_live = this.vuexState.jsonContent_live;
                    this[side].jsonContent_stage = this.vuexState.jsonContent_stage;
                    if (this.selectedEntry) {
                        this[side].selectedKey = this.parsedJsonKey(this.selectedEntry.completeKey)
                    } else {
                        this[side].selectedKey = null;
                    }
                })
                this.initializing = false;
            }
        },
        async fetchSiteDetails(side) {
            if (this[side].selectedSite) {
                this[side].siteLoading = true;
                this[side].siteDetails = await this.$store.dispatch('editor/fetchSiteDetails', {
                    siteId: this[side].selectedSite.SiteId,
                    noCommit: true
                });
                this[side].siteLoading = false;
            }
        },
        async fetchJson(side) {
            if (this[side].selectedSitetype) {
                this[side].sitetypeLoading = true;
                let data = await this.$store.dispatch('editor/fetchJSON', {
                    id: this[side].selectedSitetype.SitetypeId,
                    return: true
                });
                const validResults = data.filter(result => !(result instanceof Error));
                let res_live = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_live_cache) !== -1 || x.config.url.indexOf(this.vuexState.baseDomain_live) !== -1);
                let res_stage = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_stage) !== -1);
                this[side].jsonContent_live = res_live ? res_live.data : {};
                this[side].jsonContent_stage = res_stage ? res_stage.data : {};
                this[side].sitetypeLoading = false;
            }
        },
        getJsonKeys(side) {
            let parsedKeys = [];
            if (this[side]['jsonContent_' + this[side].type]) {
                Object.keys(this[side]['jsonContent_' + this[side].type]).forEach((key) => {
                    parsedKeys.push(this.parsedJsonKey(key));
                });
            }
            let sortedKeys = [];
            this.vuexState.types.forEach((type) => {
                if (parsedKeys.find(x => x.type.value === type.value)) {
                    let keysOfType = parsedKeys.filter(x => x.type.value === type.value);
                    //keysOfType.sort(Utils.naturalCompare);
                    keysOfType.forEach((key) => {
                        sortedKeys.push(key);
                    })
                }
            })

            return sortedKeys;
        },
        handleChange(side, n, o) {
            if (!this.initializing && this.value) {
                if (o.selectedSite === null || (n.selectedSite && n.selectedSite.SiteId !== o.selectedSite.SiteId)) {
                    this.fetchSiteDetails(side);
                } else if ((n.selectedSitetype && (o.selectedSitetype === null || typeof o.selectedSitetype === "undefined")) || ((typeof o.selectedSitetype !== "undefined" && typeof n.selectedSitetype !== "undefined") &&
                    (n.selectedSitetype && o.selectedSitetype) &&
                    (n.selectedSitetype.SitetypeId !== o.selectedSitetype.SitetypeId))) {
                    this.fetchJson(side);
                }
            }
        },
        parsedJsonKey(key) {
            return Utils.parseJSONKey(key, this.vuexState.types, this.vuexState.teasertypes);
        }
    }
    ,
    watch: {
        c_left: {
            handler: function (n, o) {
                this.handleChange('left', n, o);
            }, deep: true
        }
        ,
        c_right: {
            handler: function (n, o) {
                this.handleChange('right', n, o);
            }, deep: true
        },
        value() {
            if (this.value) this.init();
        }
    }

}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item {
    padding-top: 5px;
    padding-bottom: 5px;
}

::v-deep .d2h-wrapper {
    tr {
        height: 17px;
    }

    .d2h-code-side-line, .d2h-wrapper .d2h-code-line {
        width: auto;
        font-size: 12px;
    }

    .d2h-diff-table {
        font-size: 12px;
        margin-bottom: 5px;
    }

    ::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    ::-webkit-scrollbar:vertical {
        width: 10px;
    }

    ::-webkit-scrollbar:horizontal {
        height: 10px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 2px solid white; /* should match background, can't be transparent */
        background-color: rgba(0, 0, 0, .4);
    }

    ::-webkit-scrollbar-track {
        background-color: #fff;
        border-radius: 8px;
    }
}

::v-deep .siteDropdown {
    .v-input__slot {
        padding: 0;
    }
}
</style>